<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
	<template slot="bodyForm">
		<CLoader :pConfigLoad="ConfigLoad">
		<template slot="BodyFormLoad">
			<form id="FormCotizacion" role="form" method="post" autocomplete="off" onSubmit="return false">

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<p class="text-uppercase text-sm">Datos Informativos</p>
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
						<label class="form-label" for="Nombres">Tipo de Evento</label>
						<select v-model="objCotizacion.TipoBoda" @change="SetearEtiqueta()" class="form-select form-control-search">
							<option value="0">Seleccione una opción</option>
							<option v-for="(item,index) in ListaTiposDeEventos" :key="index" :value="item.IdTipoEvento">{{item.Nombre}}</option>
						</select>
						<CValidation v-if="this.errorvalidacion.TipoBoda" :Mensaje="'*'+errorvalidacion.TipoBoda[0]"/>
					</div>

					<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
						<label class="form-label" for="FechaReg">Fecha Principal</label>
						<div class="calendar">
							<Datepicker v-model="objCotizacion.FechaBoda" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
						</div>
						<CValidation v-if="this.errorvalidacion.FechaBoda" :Mensaje="'*'+errorvalidacion.FechaBoda[0]"/>
					</div>

					<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
						<label class="form-label" for="Folio">Folio Cotización</label>
						<input type="text" v-model="objCotizacion.Folio" class="form-control" id="Folio" placeholder="Ingresar Folio" readonly />
						<CValidation v-if="this.errorvalidacion.Folio" :Mensaje="'*'+errorvalidacion.Folio[0]"/>
					</div>

					<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
						<label class="form-label" for="Comision">Comisión %</label>
						<input type="text" v-model="Comision" class="form-control" id="Comision" placeholder="Ingresar Comisión" readonly />
						<CValidation v-if="this.errorvalidacion.Comision" :Mensaje="'*'+errorvalidacion.Comision[0]"/>
					</div>

					<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<label class="form-label" for="Telefono">Creado Por</label>
						<input type="text" v-model="Cotizo" class="form-control" id="Telefono" placeholder="Ingresar Telefono" readonly />
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
						<label class="form-label" for="Nombres">{{objCotizacion.EtiquetaEvento}}</label>
						<input type="text" v-model="objCotizacion.Nombres" class="form-control" id="Nombres" :placeholder="'Ingresar '+objCotizacion.EtiquetaEvento" />
						<CValidation v-if="this.errorvalidacion.Nombres" :Mensaje="'*'+errorvalidacion.Nombres[0]"/>
					</div>

					<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
						<label class="form-label" for="Nombres">Ejecutiva(o) Asignada(o)</label>
						<input type="text" v-model="Vendedor" class="form-control" id="Nombres" placeholder="Ingresar" readonly />
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
						<label class="form-label" for="IdAgente">Hotel / Empresa</label>
						<select v-model="objCotizacion.IdAgente" @change="GetListContactos()" class="form-select form-control-search">
							<option value="0">Seleccione una opción</option>
							<option v-for="(item,index) in ListaAgentes" :key="index" :value="item.IdAgente">{{item.NombreComercial}}</option>
						</select>
						<CValidation v-if="this.errorvalidacion.IdAgente" :Mensaje="'*'+errorvalidacion.IdAgente[0]"/>
					</div>
					
					<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
						<label class="form-label" for="Email">Contacto Cliente</label>
						<select v-model="objCotizacion.IdContacto" class="form-select form-control-search">
							<option value="0">Seleccione una opción</option>
							<option v-for="(item,index) in ListaContactos" :key="index" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
						</select>
						<CValidation v-if="this.errorvalidacion.IdContacto" :Mensaje="'*'+errorvalidacion.IdContacto[0]"/>
					</div>
				</div>

				<hr class="horizontal dark">

				<div class="row">
					<div class="col-6 col-sm-6 col-md-6 col-lg-6">
						<p class="text-uppercase text-sm">Datos del Evento</p>
					</div>

					<div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
						<button type="button" @click="AgregarActividad({})" class="btn btn-sm btn-primary">
							<i class="fa fa-plus"></i> Nuevo
						</button>
					</div>
				</div>

				<div class="form-group row">
					<div v-for="(item,index) in ListaEventos" class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" :key="index">

						<div class="card">
							<div class="card-header px-3 pt-1 pb-0">
								<div class="row">
									<div class="col-12">
										<h6 class="mb-0 text-green-black">{{item.Evento}}</h6>
										<p class="text-xs  font-weight-bold"><i class="far fa-calendar-day"></i> {{formatfecha(item)}} <i class="far fa-clock"></i> {{item.HoraEvento}}</p>
									</div>
								</div>
							</div>

							<div class="card-body px-3 pt-0 pb-1">
								<div class="row">
									<!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6">
									</div> -->
									<div class="col-12 col-sm-12 col-md-6 col-lg-6">
										<div class="d-flex flex-column">
											<h6 class="mb-1 text-sm text-end">Elementos</h6>
											<span class="text-xs text-end">Total: <span class="text-dark ms-sm-2 font-weight-bold">$ {{item.TotalGrupal}}</span></span>
										</div>
									</div>
									<div class="col-12 col-sm-12 col-md-6 col-lg-6">
										<div class="d-flex flex-column">
											<h6 class="mb-1 text-sm text-end">Paquetes</h6>
											<span class="text-xs text-end">Total: <span class="text-dark ms-sm-2 font-weight-bold">$ {{ CalcularTotalPaquete(item.Paquetes) }}</span></span>
										</div>
									</div>

									<hr class="horizontal dark my-3">

									<div class="col-12 text-end mt-n3">
										<button type="button" @click="EliminarEvento(index)" class="btn btn-link text-danger text-gradient px-1 mb-0">
											<i class="far fa-trash-alt me-2" aria-hidden="true"></i>Eliminar
										</button>

										<button type="button" @click="AgregarActividad(item)" class="btn btn-link text-dark px-1 mb-0">
											<i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i>Editar
										</button>
									</div>
								</div>
							</div>
						</div>
						
					</div>

					<div class="col-lg-12" v-for="(item,index) in errorvalidaciongaleria" :key="index">
						<CValidation :Mensaje="item"></CValidation>
					</div>

					<div class="col-lg-12" v-for="(item,index) in errorvalidacionpaquetes" :key="index">
						<CValidation :Mensaje="item" />
					</div>
				</div>

				<br>
				<div class="row">
                    <div class="col-12 col-sm-12 col-md-9 col-lg-6">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <h6 class="fs-6 mt-2 text-blue">Gran Total: $ {{objCotizacion.TotalGlobal}}</h6>
                            </div>
							<div class="col-12 col-sm-12 col-md-4 col-lg-4">
								<h6 class="fs-6 text-blue mt-2">Total Elementos: $ {{objCotizacion.TotalGlobalElementos}}</h6>
							</div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <h6 class="fs-6 mt-2 text-blue">Total Paquetes: $ {{objCotizacion.TotalGlobalPaqt}}</h6>
                            </div>
                        </div>
                    </div>

					<div class="col-12 col-sm-12 col-md-6 col-lg-6 text-end">
						<CBtnSave :poBtnSave="oBtnSave" />
					</div>
				</div>
			</form>

			<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSaveM">
				<template slot="Form">
					<Form :poBtnSave="oBtnSaveM"></Form>
				</template>
			</CModal>
		</template>
		</CLoader>
	</template>
	</CList>
   
</template>
<script>
import Calendar from '@/helpers/StaticComboBox.js';
import Configs from '@/helpers/VarConfig.js';

import moment from 'moment';
import Form from '@/views/modulos/crm/cliente/FormActividad.vue';
const EmitEjecuta = 'seccionCotizacion';
const EmitEjecutaM = 'seccionActividades';

export default {
    name: 'FormCotizacion',
    props: ['Id'],
    components:{
		Form
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario Cotización',
				ShowTitleFirst: false,
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'cotizacion',
                EmitSeccion: EmitEjecuta,
            },
			ConfigModal:{
                ModalTitle: "Actividades",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecutaM,
                ModalSize: 'xl',
				FullScreen: true,
            },
            oBtnSaveM: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecutaM,
            },
            objCotizacion: {
				IdCotizacion: 0,
				IdBodaCopia: 0,
				IdCliente: 0,
				IdVendedor: 0,
				IdAgente: 0,
				IdContacto: 0,
				FechaCotizacion: '',
				TipoBoda: 0,
				EtiquetaEvento: 'Nombres',
				Nombres: '',
				Folio: '',
				Estatus: '',
				TotalGlobal: 0,
				FechaBoda: '',
				TotalGlobalPaqt: 0,
				EventoConfirm: '',
				FechaModif: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				DeEmpresa: 0,
				IdUsuario: 0,
				// HELPER
				TotalGlobalElementos: 0
            },
            segurity: {},
            errorvalidacion: [],
			errorvalidaciongaleria: [],
			errorvalidacionpaquetes: [],
			Emit: EmitEjecuta,
			ListaTiposDeEventos: [],
			ListaAgentes: [],
			ListaContactos: [],
			ListaEventos: [],
			Setpicker: Calendar.calendarSettings,
			Cotizo: '',
			Vendedor: '',
			Comision: '',
			ListaEventosDelete: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			if(this.objCotizacion.FechaBoda!=''){
				this.objCotizacion.FechaBoda = moment(this.objCotizacion.FechaBoda).format('YYYY-MM-DD');
			}

			let formData = new FormData();
			formData.set('IdCotizacion', this.objCotizacion.IdCotizacion);
			formData.set('IdBodaCopia', this.objCotizacion.IdBodaCopia);
			formData.set('IdCliente', this.objCotizacion.IdCliente);
			formData.set('IdAgente', this.objCotizacion.IdAgente);
			formData.set('IdContacto', this.objCotizacion.IdContacto);
			formData.set('Nombres', this.objCotizacion.Nombres);
			formData.set('FechaCotizacion', this.objCotizacion.FechaCotizacion);
			formData.set('TipoBoda', this.objCotizacion.TipoBoda);
			formData.set('Folio', this.objCotizacion.Folio);
			formData.set('Estatus', this.objCotizacion.Estatus);
			formData.set('TotalGlobal', this.objCotizacion.TotalGlobal);
			formData.set('FechaBoda', this.objCotizacion.FechaBoda);
			formData.set('TotalGlobalPaqt', this.objCotizacion.TotalGlobalPaqt);
			formData.set('EventoConfirm', this.objCotizacion.EventoConfirm);
			formData.set('FechaModif', this.objCotizacion.FechaModif);
			formData.set('IdEmpresa', this.objCotizacion.IdEmpresa);
			formData.set('IdSucursal', this.objCotizacion.IdSucursal);
			formData.set('DeEmpresa', this.objCotizacion.DeEmpresa);
			formData.set('IdUsuario', this.objCotizacion.IdUsuario);

			formData.set('ListEventos', JSON.stringify(this.ListaEventos));
			formData.set('ListEventosDelete', JSON.stringify(this.ListaEventosDelete));
			
			this.errorvalidacion = [];
			this.errorvalidaciongaleria=[];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('cotizaciones', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            } else if (err.response.data.tipo == 1){
				this.errorvalidacionpaquetes=err.response.data.error;
                this.$toast.error(err.response.data.message);
            } else {
                this.$toast.error(err.response.data.message);
				this.errorvalidaciongaleria=err.response.data.error;
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cotizaciones/"+this.objCotizacion.IdCotizacion
            ).then((res) => {
                this.objCotizacion = res.data.data;

				// en caso de que necesite fecha
				let formatedDate1 = this.objCotizacion.FechaBoda.replace(/-/g,'\/');
                this.objCotizacion.FechaBoda = new Date(formatedDate1);
				this.SetearEtiqueta();
				this.GetListContactos();

				let response = [];

				res.data.eventos.map(function(element){
					element.EliminarDetalles = [];
					element.PaquetesEliminados = [];
					element.BorrarImagenesTemp = [];
					// element.IvaPqt = 0;
					element.SubTotalIvaPqt = 0;
					element.SubTotalPqt = 0;
					element.TotalGrupalPqt = 0;
					element.Paquetes.forEach(paq => {
						paq.Selected = true;
						paq.EstiloEsp = true;
						paq.EstiloIng = false;
						paq.SubTotal = paq.Precio;
						paq.SubTotalIva = paq.Precio * 0.16;
						paq.TotalGrupal = paq.Precio * 1.16
						paq.ListaElementos.forEach(elem => {
                            elem.EstiloEsp = true;
							elem.EstiloIng = false;
						})
					})

					response.push(structuredClone(element));
				});

				this.ListaEventos = response;

				this.Cotizo = res.data.cotizo;
				this.Vendedor = res.data.vendedor;
				this.Comision = res.data.comision;
				
            }).finally(()=>{
				this.CalcularTotalGlobal();
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCotizacion = {
				IdCotizacion: 0,
				IdBodaCopia: 0,
				IdCliente: 0,
				IdAgente: 0,
				IdContacto: 0,
				FechaCotizacion: '',
				TipoBoda: 0,
				Folio: '',
				Estatus: '',
				TotalGlobal: 0,
				FechaBoda: '',
				TotalGlobalPaqt: 0,
				EventoConfirm: '',
				FechaModif: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				DeEmpresa: 0,
				IdUsuario: 0,
				
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
		GetListTipoEventos()
		{
			this.$http.get('tipoEventos', {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.ListaTiposDeEventos = res.data.data;
			});
		},
		SetearEtiqueta()
		{
			let buscar = this.objCotizacion.IdTipoEvento;

			let objv = this.ListaTiposDeEventos.filter((elem)=>{
				if(buscar == elem.IdTipoEvento) return elem;
			});

			let Etiqueta = 'Nombres';
			if(objv[0]){
				if(objv[0].Etiqueta !=''){
					Etiqueta = objv[0].Etiqueta;
				}
			}

			this.objCotizacion.EtiquetaEvento = Etiqueta;
		},
		GetListAgentes()
		{
			this.$http.get('agentes', {
				params:{
					simple: 1,
				}
			}).then( (res) => {
				this.ListaAgentes = res.data.data;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
		},
		GetListContactos()
		{
			if(this.objCotizacion.IdAgente !=0)
			{
				this.$http.get('solicitudContacto', {
					params:{
						IdAgente: this.objCotizacion.IdAgente,
					}
				}).then( (res) => {
					this.ListaContactos = res.data.data;
				});
			}
			else
			{
				this.objCotizacion.IdContacto = 0;
				this.ListaContactos = [];
			}
		},
		AgregarActividad(item)
		{
			let nuevoObj = {};
			if(Object.keys(item).length !== 0)
			{
				if(item.Elementos.length>0)
				{
					let iteracion = [];
					item.Elementos.map((element)=>{
						element.EstiloEsp = true;
						element.EstiloIng = false;
						element.EstiloNot = false;

						iteracion.push(element);
					});

					let formatedDate1 = item.FechaEvento.replace(/-/g,'\/');
					let newFechaEvento = new Date(formatedDate1);

					let formatedDate2 = item.FechaMontaje.replace(/-/g,'\/');
					let newFechaMontaje = new Date(formatedDate2);

					let formatedDate3 = item.FechaDesmontaje.replace(/-/g,'\/');
					let newFechaDesMontaje = new Date(formatedDate3);

					let HoraEvento = moment(item.HoraEvento,'hhmm').format('HH:mm');
					let HoraMontaje = moment(item.HoraMontaje,'hhmm').format('HH:mm');
					let HoraDesMontaje = moment(item.HoraDesMontaje,'hhmm').format('HH:mm');

					nuevoObj = {
						IdCotizacion: item.IdCotizacion,
						IdCotizacionEvento: item.IdCotizacionEvento,
						Evento: item.Evento,
						FechaEvento: newFechaEvento,
						FechaMontaje: newFechaMontaje,
						FechaDesmontaje: newFechaDesMontaje,
						HoraEvento: HoraEvento,
						HoraMontaje: HoraMontaje,
						HoraDesMontaje: HoraDesMontaje,
						Locacion: item.Locacion,
						BackUp: item.BackUp,
						Descripcion: item.Descripcion,
						Iva: item.Iva,
						SubTotalIva: item.SubTotalIva,
						SubTotal: item.SubTotal,
						TotalGrupal: item.TotalGrupal,
						SubTotalIvaPqt: item.SubTotalIvaPqt,
						SubTotalPqt: item.SubTotalPqt,
						TotalGrupalPqt: item.TotalGrupalPqt,
						Elementos: iteracion,
						Paquetes: item.Paquetes,
						PaquetesEliminados: item.PaquetesEliminados,
						EliminarDetalles: item.EliminarDetalles,
						BorrarImagenesTemp: item.BorrarImagenesTemp
					};
				}
				else{
					nuevoObj = item;
				}
			}
			else{
				nuevoObj = item;
			}
			
			this.bus.$emit('NewModal_'+EmitEjecutaM,this.objCotizacion,nuevoObj);
		},
		formatfecha(item)
		{
			let fecha = moment(item.FechaEvento).format('YYYY-MM-DD');
			return fecha;
		},
		CalcularTotalGlobal()
		{
			let TotalElem = 0;
			let TotalPaq = 0;
            let SubTotal = 0;
            let Arreglo = this.ListaEventos;

			for(let i=0; i<Arreglo.length; i++)
            {
				let valor = Arreglo[i].TotalGrupal;
				TotalElem+= isNaN(valor) ? 0: parseFloat(valor);
				let sumaPaquetes = Arreglo[i].Paquetes.reduce((acc, current) => acc + current.TotalGrupal, 0);
				TotalPaq += isNaN(sumaPaquetes) ? 0 : parseFloat(sumaPaquetes)
			}
			this.objCotizacion.TotalGlobalElementos =  parseFloat(TotalElem).toFixed(2);
			this.objCotizacion.TotalGlobalPaqt = parseFloat(TotalPaq).toFixed(2);
			this.objCotizacion.TotalGlobal = parseFloat(TotalElem + TotalPaq).toFixed(2);
		},
		ResetearEvento(obj)
		{
			let buscar = obj.IdCotizacionEvento;
			let evento = this.ListaEventos.filter(function(element){
				if(element.IdCotizacionEvento == buscar){
					return element;
				}
				else{
					return '';
				}
			});

			if(evento[0])
			{
				evento[0].Evento 			= obj.Evento;
				evento[0].FechaEvento 		= obj.FechaEvento;
				evento[0].FechaMontaje 		= obj.FechaMontaje;
				evento[0].FechaDesmontaje 	= obj.FechaDesmontaje;
				evento[0].HoraEvento 		= obj.HoraEvento;
				evento[0].HoraMontaje 		= obj.HoraMontaje;
				evento[0].HoraDesMontaje	= obj.HoraDesMontaje;
				evento[0].Locacion 			= obj.Locacion;
				evento[0].BackUp 			= obj.BackUp;
				evento[0].Descripcion 		= obj.Descripcion;
				evento[0].Iva 				= obj.Iva;
				evento[0].SubTotalIva 		= obj.SubTotalIva;
				evento[0].SubTotal 			= obj.SubTotal;
				evento[0].TotalGrupal 		= obj.TotalGrupal;
				evento[0].Elementos 		= obj.Elementos;
				evento[0].Paquetes 			= obj.Paquetes;
				evento[0].PaquetesEliminados= obj.PaquetesEliminados;
				evento[0].EliminarDetalles	= obj.EliminarDetalles;
				evento[0].BorrarImagenesTemp= obj.BorrarImagenesTemp;
			}
		},
		CalcularTotalPaquete(arr) {
			return arr.reduce((acc, current) => acc + current.TotalGrupal, 0);
		},
		EliminarEvento(index)
		{
			let item = this.ListaEventos[index];

			this.$swal(Configs.configEliminar).then((result) =>
			{
				if(result.value)
				{
					// SE COLOCAN LOS EVENTOS PARA ELIMINAR
					this.ListaEventosDelete.push(item);
					this.ListaEventos.splice(index, 1);
					this.CalcularTotalGlobal();
				}
			});
		},
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

		if(this.Id != undefined){
			sessionStorage.setItem('IdCotizacion',this.Id);
		}

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
		this.bus.$off('SetearEvento');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
		this.GetListTipoEventos();
		this.GetListAgentes();

		let Id = sessionStorage.getItem('IdCotizacion');

        if(Id>0)
        {
            this.objCotizacion.IdCotizacion = Id;
            this.Recuperar();
        }
		else
		{
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.Cotizo = user.NombreCompleto;
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

		
		this.bus.$on('SetearEvento',(obj)=>
		{
			if(obj.IdCotizacionEvento>0)
			{
				this.ResetearEvento(obj);
			}
			else
			{
				this.ListaEventos.push(obj);
			}
			this.CalcularTotalGlobal();
		});
    }
}
</script>
